import { InternalNetworkAdEntityKindSchema } from '@terra/shared-schemas-orchestrator';
import { z } from 'zod';
import { InternalNetworkAttackPathEventStatusSchema } from './internal-network-attack-path.schema';
import {
  InternalNetworkAssessmentProgressCredentialSchema,
  InternalNetworkAssessmentProgressFootholdEventKindSchema,
  InternalNetworkAssessmentProgressFootholdStatusSchema,
} from './internal-network-assessment-foothold.schema';

export const InternalNetworkAssessmentEntityKindSchema = z.enum([
  'HOST',
  'PRINCIPAL',
  'GOAL',
]);

export const InternalNetworkAssessmentSignalExecutionStatusSchema = z.enum([
  'RUNNING',
  'SUCCEEDED',
  'FAILED',
  'PENDING',
]);

export const InternalNetworkAssessmentEntitySchema = z.object({
  id: z.string(),
  kind: InternalNetworkAssessmentEntityKindSchema,
  label: z.string(),
  status: InternalNetworkAssessmentProgressFootholdStatusSchema.nullable(),
  adEntityId: z.string().nullable(),
  adEntityKind: InternalNetworkAdEntityKindSchema.nullable(),
  principalId: z.string().nullable(),
  hostname: z.string().nullable(),
  goalKey: z.string().nullable(),
});

export const InternalNetworkAssessmentActionSchema = z.object({
  id: z.string(),
  sourceEntityId: z.string(),
  targetEntityId: z.string(),
  status: InternalNetworkAttackPathEventStatusSchema,
  eventKind: InternalNetworkAssessmentProgressFootholdEventKindSchema,
  technique: z.string().nullable(),
  mitreTechniqueId: z.string().nullable(),
  weaknessId: z.string().nullable(),
  lastEventId: z.string().nullable(),
  signalId: z.string().nullable(),
  occurredAt: z.iso.datetime().nullable(),
});

export const InternalNetworkAssessmentSignalExecutionSchema = z.object({
  signalId: z.string(),
  predecessorSignalId: z.string().nullable(),
  primaryExecutionId: z.string().nullable(),
  objective: z.string().nullable(),
  status: InternalNetworkAssessmentSignalExecutionStatusSchema,
  startedAt: z.iso.datetime().nullable(),
  lastActivityAt: z.iso.datetime().nullable(),
  entityIds: z.array(z.string()),
  actionIds: z.array(z.string()),
});

export const InternalNetworkAssessmentEntityActionGraphSchema = z.object({
  networkId: z.string(),
  assessmentId: z.string(),
  generatedAt: z.iso.datetime(),
  completed: z.boolean(),
  reachedCrownJewel: z.string().nullable(),
  entities: z.array(InternalNetworkAssessmentEntitySchema),
  actions: z.array(InternalNetworkAssessmentActionSchema),
  signalExecutions: z.array(InternalNetworkAssessmentSignalExecutionSchema),
  credentialsGained: z.array(InternalNetworkAssessmentProgressCredentialSchema),
  impactsAchieved: z.array(z.string()),
});

export type InternalNetworkAssessmentEntityKind = z.infer<
  typeof InternalNetworkAssessmentEntityKindSchema
>;
export type InternalNetworkAssessmentSignalExecutionStatus = z.infer<
  typeof InternalNetworkAssessmentSignalExecutionStatusSchema
>;
export type InternalNetworkAssessmentEntityDto = z.infer<
  typeof InternalNetworkAssessmentEntitySchema
>;
export type InternalNetworkAssessmentActionDto = z.infer<
  typeof InternalNetworkAssessmentActionSchema
>;
export type InternalNetworkAssessmentSignalExecutionDto = z.infer<
  typeof InternalNetworkAssessmentSignalExecutionSchema
>;
export type InternalNetworkAssessmentEntityActionGraphDto = z.infer<
  typeof InternalNetworkAssessmentEntityActionGraphSchema
>;
